<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col flex-auto">
      <legend class="usa-legend usa-legend--large">FRT Rate Filing Administration</legend>
    </div>
    <div class="grid-col flex-auto margin-left-2">
      <ul class="usa-nav__primary usa-accordion">
        <li class="usa-nav__primary-item">
          <button class="usa-accordion__button define-eclipse" aria-expanded="false" aria-controls="more-actions"
            data-tooltip="Click for more options">
            <span>&hellip;</span>
          </button>
          <ul id="more-actions" class="usa-nav__submenu" hidden>
            <li class="usa-nav__submenu-item">
              <a (click)="openExtendRates()">Extend Current Rates</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <form [formGroup]="frtRatesBidcyclesForm">
    <fieldset class="usa-fieldset">
      @if (isError) {
        <div class="usa-alert usa-alert--error usa-alert--slim">
          <div class="usa-alert__body">
            <p class="usa-alert__text">
              {{errorMessage}}
            </p>
          </div>
        </div>
      }
      <div class="grid-row grid-gap-2">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <legend class="usa-legend usa-legend--medium">Rate</legend>
          <div class="grid-row">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label fo   r="bidCycle" class="usa-label">Bid Cycle Name<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" id="bidCycle" class="usa-input maxw-full" formControlName="bidCycle" (change)="onCycleNameChange($event)">
              @if (this.frtRatesBidcyclesForm.get('bidCycle').touched && this.frtRatesBidcyclesForm.get('bidCycle').hasError('required')) {
                <small class="define-text-secondary">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg>Bidcycle name is required.
                </small>
              }
              @if (this.frtRatesBidcyclesForm.get('bidCycle').touched && this.bidcycleError) {
                <small class="define-text-secondary">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg>Bidcycle name is already available. Please use another name.
                </small>
              }
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="tsp_open_date" class="usa-label">Rate Filing Open Date<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" id="bid_open_date" class="usa-input maxw-full" placeholder="mm/dd/yyyy" formControlName="bidOpenDate" (bsValueChange)="bidOpenDateChange($event)" [minDate]="bidOpenMinDate" [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                [value]="this.frtRatesBidcyclesForm.get('bidOpenDate').value | date: 'MMM d, y'" bsDatepicker placement="right">

                @if (this.frtRatesBidcyclesForm.get('bidOpenDate').touched && this.frtRatesBidcyclesForm.get('bidOpenDate').hasError('required')) {
                  <small class="define-text-secondary">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>Rate Filing Open Date is required.
                  </small>
                }
                @if (this.frtRatesBidcyclesForm.get('bidOpenDate').touched && (this.bidOpenDateErrorType == 'A')) {
                  <small class="define-text-secondary">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>Rate Filing Open Date should be after Today.
                  </small>
                }
                @if (this.frtRatesBidcyclesForm.get('bidOpenDate').touched && this.frtRatesBidcyclesForm.get('bidCloseDate').touched && (this.bidOpenDateErrorType == 'B')) {
                  <small class="define-text-secondary">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>Rate Filing Open Date should be on or before Bid Close Date.
                  </small>
                }
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="bid_close_date" class="usa-label">Rate Filing Close Date<abbr title="required"
                class="usa-hint usa-hint--required">*</abbr></label>
                <div class="grid-row grid-gap">
                  <div class="grid-col-8 mobile-lg:grid-col-8 tablet:grid-col-8 desktop:grid-col-8">
                    <div class="usa-date-picker usa-date-picker--initialized" data-min-date="0000-01-01">
                      <input class="usa-input usa-date-picker__internal-input" aria-labelledby="appointment-date-label"
                        aria-describedby="appointment-date-hint" aria-hidden="true" tabindex="-1" style="display: none;" >
                        <div class="usa-date-picker__wrapper">
                          <input class="usa-input usa-date-picker__external-input" formControlName="bidCloseDate"
                            id="bid-CloseDate" name="bid-CloseDate" aria-labelledby="bid-CloseDate-label"
                            aria-describedby="bid-CloseDate-hint" type="text" (change)="bidCloseDateChange($event)">
                            <button type="button" class="usa-date-picker__button tmss-datepicker-custom" aria-haspopup="true"
                            aria-label="Toggle calendar" [disabled]="frtBidCycleClosedDate"></button>
                            <div class="usa-date-picker__calendar" role="application" hidden=""></div>
                            <div class="usa-sr-only usa-date-picker__status" role="status" aria-live="polite"></div>
                          </div>
                        </div>
                      </div>

                      <div class="grid-col-4 mobile-lg:grid-col-4 tablet:grid-col-4 desktop:grid-col-4">
                        <select class="usa-select usa-combo-box__select tmss-custom-select" name="options" id="options" formControlName="timeSelection">
                          @for (hr of this.listHrs; track hr) {
                            <option [value]="hr.key">{{hr.value}}</option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <!-- <label for="bid_close_date" class="usa-label">Rate Filing Close Date<abbr title="required"
                  class="usa-hint usa-hint--required">*</abbr></label>
                  <ngx-datetime-picker disableInput="true" id="delivery-date" id="bid_close_date" class="maxw-full" formControlName="bidCloseDate" (selectedDateTimeChange)="bidCloseDateChange($event)" [disableButton]=disableUpdateButton>
                  </ngx-datetime-picker> -->
                  @if (this.frtRatesBidcyclesForm.get('bidCloseDate').touched && this.frtRatesBidcyclesForm.get('bidCloseDate').hasError('required')) {
                    <small class="define-text-secondary">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg>Rate Filing Close Date is required.
                    </small>
                  }
                  @if (this.bidCloseDateError && (this.bidCloseDateErrorType == 'A')) {
                    <small class="define-text-secondary">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg>Rate Filing Close Date should be after Today.
                    </small>
                  }
                  @if (this.bidCloseDateError && (this.bidCloseDateErrorType == 'B')) {
                    <small class="define-text-secondary">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg>Rate Filing Close Date should be after Rate Filing Open Date.
                    </small>
                  }
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                  <label class="usa-label" for="eff_open_date">Rate Effective Date<abbr title="required"
                  class="usa-hint usa-hint--required">*</abbr></label>
                  <input type="text" id="eff_open_date" class=" usa-input maxw-full" placeholder="mm/dd/yyyy" formControlName="effOpenDate" (bsValueChange)="effOpenDateChange($event)" [minDate]="effOpenMinDate" [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                    [value]="this.frtRatesBidcyclesForm.get('effOpenDate').value | date: 'MMM d, y'" bsDatepicker placement="right">
                    @if (this.frtRatesBidcyclesForm.get('effOpenDate').touched && this.frtRatesBidcyclesForm.get('effOpenDate').hasError('required')) {
                      <small class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg>Rate Effective Date is required.
                      </small>
                    }
                    @if (this.frtRatesBidcyclesForm.get('effOpenDate').touched && (this.effOpenDateErrorType == 'A')) {
                      <small class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg>Rate Effective Date should be after Today.
                      </small>
                    }
                    @if (this.effOpenDateError && (this.effOpenDateErrorType == 'B')) {
                      <small class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg>Rate Effective Date should be After Rate Filing Close Date.
                      </small>
                    }
                  </div>
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <label class="usa-label" for="eff_close_date">Rate Expiry Date<abbr title="required"
                    class="usa-hint usa-hint--required">*</abbr></label>
                    <input type="text" id="eff_close_date" class="maxw-full usa-input" placeholder="mm/dd/yyyy" formControlName="effCloseDate" (bsValueChange)="effCloseDateChange($event)" [minDate]="effCloseMinDate" [value]="this.frtRatesBidcyclesForm.get('effCloseDate').value | date: 'MMM d, y'"
                      [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}" bsDatepicker [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}" placement="right">
                      @if (this.frtRatesBidcyclesForm.get('effCloseDate').touched && this.frtRatesBidcyclesForm.get('effCloseDate').hasError('required')) {
                        <small class="define-text-secondary">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg>Rate Expiry Date is required.
                        </small>
                      }
                      @if (this.frtRatesBidcyclesForm.get('effCloseDate').touched && (this.effCloseDateErrorType == 'A')) {
                        <small class="define-text-secondary">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg>Rate Expiry Date should be after Today.
                        </small>
                      }
                      @if (this.frtRatesBidcyclesForm.get('effCloseDate').touched && (this.effCloseDateErrorType == 'B')) {
                        <small class="define-text-secondary">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg>Rate Expiry Date should be after Rate Effective Date.
                        </small>
                      }
                    </div>
                  </div>
                </div>

                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                  <legend class="usa-legend usa-legend--medium">TSP</legend>
                  <div class="grid-row">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                      <label class="usa-label" for="tsp_open_date">TSP Participation Open Date<abbr
                      title="required" class="usa-hint usa-hint--required">*</abbr></label>
                      <input type="text" id="tsp_open_date" class="maxw-full usa-input" placeholder="mm/dd/yyyy" formControlName="tspOpenDate" (bsValueChange)="tspOpenDateChange($event)" [minDate]="tspOpenMinDate" [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                        [value]="this.frtRatesBidcyclesForm.get('tspOpenDate').value | date: 'MMM d, y'" bsDatepicker placement="right">
                        @if (this.frtRatesBidcyclesForm.get('tspOpenDate').touched && this.frtRatesBidcyclesForm.get('tspOpenDate').hasError('required')) {
                          <small class="define-text-secondary">
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                            </svg>Tsp Participation Open Date is required.
                          </small>
                        }
                        @if (this.frtRatesBidcyclesForm.get('tspOpenDate').touched && (this.tspOpenDateErrorType == 'A')) {
                          <small class="define-text-secondary">
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                            </svg>Tsp Participation Open Date should be after Today.
                          </small>
                        }
                        @if (this.frtRatesBidcyclesForm.get('tspOpenDate').touched &&
                          this.frtRatesBidcyclesForm.get('tspCloseDate').touched &&
                          (this.tspOpenDateErrorType == 'B')) {
                          <small class="define-text-secondary">
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                            </svg>Tsp Participation Open Date should be on or before Tsp Participation Close Date.
                          </small>
                        }
                        @if (this.frtRatesBidcyclesForm.get('tspOpenDate').touched &&
                          (this.tspOpenDateErrorType == 'C')) {
                          <small class="define-text-secondary">
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                            </svg>Tsp Participation Open Date should be on or after Rate Filing Open Date.
                          </small>
                        }
                      </div>

                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                        <label class="usa-label" for="tsp_close_date">TSP Participation Close Date<abbr
                        title="required" class="usa-hint usa-hint--required">*</abbr></label>
                        <input type="text" id="tsp_close_date" class="maxw-full usa-input" placeholder="mm/dd/yyyy" formControlName="tspCloseDate" (bsValueChange)="tspCloseDateChange($event)" [minDate]="tspCloseMinDate" [value]="this.frtRatesBidcyclesForm.get('tspCloseDate').value | date: 'MMM d, y'"
                          [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}" bsDatepicker [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}" placement="right">
                          @if (this.frtRatesBidcyclesForm.get('tspCloseDate').touched && this.frtRatesBidcyclesForm.get('tspCloseDate').hasError('required')) {
                            <small class="define-text-secondary">
                              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                              </svg>TSP Participation Close Date is required.
                            </small>
                          }

                          @if (this.frtRatesBidcyclesForm.get('tspCloseDate').touched && (this.tspCloseDateErrorType == 'A')) {
                            <small class="define-text-secondary">
                              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                              </svg>TSP Participation Close Close should be after Today.
                            </small>
                          }
                          @if (this.frtRatesBidcyclesForm.get('tspCloseDate').touched && (this.tspCloseDateErrorType == 'B')) {
                            <small class="define-text-secondary">
                              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                              </svg>TSP Participation Close Date should be after Rate Filing Open Date.
                            </small>
                          }

                          @if (this.frtRatesBidcyclesForm.get('tspCloseDate').touched && (this.tspCloseDateErrorType == 'C')) {
                            <small class="define-text-secondary">
                              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                              </svg>TSP Participation Close Date should be before Rate Filing Close Date.
                            </small>
                          }
                        </div>
                      </div>
                    </div>

                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                      <legend class="usa-legend usa-legend--medium">Fuel</legend>
                      <div class="grid-row">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                          <label class="usa-label" for="pcMiler">PC Miler Version<abbr title="required"
                          class="usa-hint usa-hint--required">*</abbr></label>
                          <select id="pcMiler" class="usa-select maxw-full" formControlName="pcMiler" (change)="onPcMilerChange($event.target.value)">
                            <option value='' selected disabled>Choose...</option>
                            @for (pcMiler of pcMilerList; track pcMiler) {
                              <option [value]="pcMiler.rateKey">
                                {{pcMiler.rateKey}}
                              </option>
                            }
                          </select>
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                          <label class="usa-label" for="fuelSur">Fuel Surcharge Version<abbr title="required"
                          class="usa-hint usa-hint--required">*</abbr></label>
                          <select id="fuelSur" class="usa-select maxw-full" formControlName="fuelSur" (change)="onFuelSurChange($event.target.value)">
                            <option value='' selected disabled>Choose...</option>
                            @for (fuelSur of fuelSurList; track fuelSur) {
                              <option [value]="fuelSur.rateKey">
                                {{fuelSur.rateKey}}
                              </option>
                            }
                          </select>
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                          <label class="usa-label" for="ltlBase">LTL Baseline Version<abbr title="required"
                          class="usa-hint usa-hint--required">*</abbr></label>
                          <select id="ltlBase" class="usa-select maxw-full" formControlName="ltlBase" (change)="onLtlBase($event.target.value)">
                            <option value='' selected disabled>Choose...</option>
                            <option [value]="1">GSA</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                      <legend class="usa-legend usa-legend--medium">SRO And Accessorials</legend>
                      <div class="grid-row grid-gap-2">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
                          <label for="all_sros" class="usa-label">List of all SROs</label>
                          <select id="all_sros" class="usa-select define-height-usa-select maxw-full" formControlName="allSros" multiple size="5">
                            <option value='' selected disabled>Choose...</option>
                            @for (sro of sroListByRateType; track sro) {
                              <option [value]="sro.sroMasterId">
                                {{sro.sroId}}
                              </option>
                            }
                          </select>
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2 text-ceter define-margin-x-y-auto">
                          <button type="button" class="usa-button width-full" (click)="moveItemsSro()">
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                              <use xlink:href="/assets/uswds/img/sprite.svg#arrow_forward"></use>
                            </svg>
                          </button>
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
                          <label for="assigned_sros" class="usa-label">SROs assigned<small
                          class="required">*</small></label>
                          <select size="5" class="usa-select define-height-usa-select maxw-full" formControlName="assignedSros" id="assigned_sros">
                            @for (sro of assignedSroList; track sro; let i = $index) {
                              <option
                                (dblclick)="handleSroMultiDropdown(i)" [value]="sro.sroMasterId">
                                {{sro.sroId}}
                              </option>
                            }
                          </select>
                          <div style="font-weight: 700;">Double click on item to remove from this list.</div>
                        </div>
                      </div>
                      <div class="grid-row grid-gap-2">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
                          <label for="all_accessorials" class="usa-label">List of all Accessorials</label>
                          <select multiple size="5" id="all_accessorials" class="usa-select define-height-usa-select maxw-full" formControlName="allAccessorials">
                            <option value='' selected disabled>Choose...</option>
                            @for (acc of frtAccMasterList; track acc) {
                              <option [value]="acc.frtAccessorialsId">
                                {{acc.accessorialCode}} - {{acc.accessorialDescription}}
                              </option>
                            }
                          </select>
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2 text-ceter define-margin-x-y-auto">
                          <button type="button" class="usa-button width-full" (click)="moveItems(this.frtRatesBidcyclesForm.value.allAccessorials)">
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                              <use xlink:href="/assets/uswds/img/sprite.svg#arrow_forward"></use>
                            </svg>
                          </button>
                        </div>
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
                          <label for="assigned_accessorials" class="usa-label">Accessorials assigned<small
                          class="required">*</small></label>
                          <select size="5" class="usa-select define-height-usa-select maxw-full" formControlName="assignedAccessorials" id="assigned_accessorials">
                            @for (acc of assignedAccList; track acc; let i = $index) {
                              <option
                                (dblclick)="handleAccMultiDropdown(i)" [value]="acc.frtAccessorialsId">
                                {{acc.accessorialCode}} - {{acc.accessorialDescription}}
                              </option>
                            }
                          </select>
                          <div style="font-weight: 700;">Double click on item to remove from this list.</div>
                        </div>
                      </div>
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                      <legend class="usa-legend usa-legend--medium">Comments</legend>
                      <div class="grid-row">
                        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                          <label class="usa-label" for="addlText">Additional Text<abbr title="required"
                          class="usa-hint usa-hint--required">*</abbr></label>
                          <textarea type="textare" id="addlText" class="usa-textarea maxw-full" maxlength="250" formControlName="addlText" (change)="onAddlText($event.target.value)"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>



                  <div class="grid-row margin-top-5">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                      <button type="button" class="usa-button" [disabled]="disableCreateBtn || disableUpdateButton" (click)="saveRateFileRec()">{{this.updateBtnText }}</button>
                      @if (showPublish) {
                        <button type="button" class="usa-button" (click)="publishBidcycle()">Publish</button>
                      }
                      <button type="button" class="usa-button usa-button--outline" (click)="clearPage()">Cancel
                      </button>
                      @if (showProduction) {
                        <button type="button" class="usa-button" (click)="releaseToProduction()">Release to Production
                        </button>
                      }
                      @if (showResetBidCycle) {
                        <button type="button" class="usa-button" (click)="onResetBidCycle()">Reset BidCycle</button>
                      }
                    </div>
                  </div>
                </fieldset>

              </form>
              <ag-grid-angular class="ag-theme-alpine"
                [rowData]="rateBidcyclesList"
                [domLayout]="domLayout"
                [pagination]="true"
                [paginationPageSize]="itemsPerPage"
                [columnDefs]="rateBidcyclesColumnDefs"
                (gridReady)="onGridReady($event)"
                headerHeight="60"
                ag-grid-resize>
              </ag-grid-angular>
            </div>
